import { combineReducers } from 'redux';

import actionTypes from './actionTypes';
import defaults from './defaults';

const MAX_PAGE_SIZE = 100;

const datasetReducer = (state = defaults.dataset, action) => {
    switch (action.type) {
        case actionTypes.FETCH_DATA_SUCCESS:
            return action.payload.dataset;
        default:
            return state;
    }
};

const isFetchingReducer = (state = defaults.isFetching, action) => {
    switch (action.type) {
        case actionTypes.FETCH_DATA_REQUEST:
            return true;
        case actionTypes.FETCH_DATA_SUCCESS:
        case actionTypes.FETCH_FILTERED_DATA_SUCCESS:
            return false;
        case actionTypes.FETCH_DATA_FAILURE:
            console.error(action.payload.error);
            return false;
        default:
            return state;
    }
};

/* Why does Reset have a payload too?
 * Because there needs to be a default sort and that default is determined by the report and time period
 */
const sortReducer = (state = defaults.sort, action) => {
    switch (action.type) {
        case actionTypes.RESET_SORT:
        case actionTypes.HYDRATE_SORT:
        case actionTypes.SET_SORT:
            return action.payload.sortData;
        default:
            return state;
    }
};

const pageReducer = (state = defaults.page, action) => {
    switch (action.type) {
        case actionTypes.HYDRATE_PAGE:
        case actionTypes.SET_PAGE:
            return action.payload.page;
        case actionTypes.RESET_PAGINATION:
            return defaults.page;
        default:
            return state;
    }
};

const pageSizeReducer = (state = defaults.pageSize, action) => {
    switch (action.type) {
        case actionTypes.HYDRATE_PAGE_SIZE:
        case actionTypes.SET_PAGE_SIZE:
            return action.payload.pageSize <= MAX_PAGE_SIZE ? action.payload.pageSize : MAX_PAGE_SIZE;
        default:
            return state;
    }
};

const reducer = combineReducers({
    dataset: datasetReducer,
    isFetching: isFetchingReducer,
    sort: sortReducer,
    page: pageReducer,
    pageSize: pageSizeReducer,
});

export default reducer;
